import { Box, Portal } from '@mantine/core';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { useStyles } from './SideMenuPortal.styles';
import { useSelectableStore } from '@/components/Selectable';
import { cloneI18n } from '@/utils/i18n';
import { useUiLanguage } from '@/utils/useUiLanguage';
import { useContentObject } from '@/widgets/_components/ContentObjectProvider';

export function useContentObjectIsSelected() {
  const { id } = useContentObject();
  return useSelectableStore(state => state.itemConfigId === id || state.selectedId === id);
}

type SideMenuPortalProps = {
  children: ReactNode;
};

export function SideMenuPortalBase(props: SideMenuPortalProps) {
  const { children } = props;
  const { classes } = useStyles();

  return (
    <Portal target="#studio-settings-portal">
      <Box className={classes.wrapper} data-testid="widget-side-menu">
        {children}
      </Box>
    </Portal>
  );
}

export function SideMenuPortal(props: SideMenuPortalProps) {
  const { children } = props;
  const isContentObjectSelected = useContentObjectIsSelected();

  const { i18n } = useTranslation();
  const { uiLanguage } = useUiLanguage();
  const i18nClone = cloneI18n(i18n, uiLanguage);

  return (
    <>
      {isContentObjectSelected && (
        <I18nextProvider i18n={i18nClone}>
          <SideMenuPortalBase>{children}</SideMenuPortalBase>
        </I18nextProvider>
      )}
    </>
  );
}
